// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EW99l","controls":"styles_controls__yNkpv","charLimit":"styles_charLimit__1A3lX","input":"styles_input__1JkCh","send":"styles_send__7K8P0"};